import SmoothScroll from 'smooth-scroll';

export const DEFAULT_DURATION = 750;
window.SmoothScroll = SmoothScroll;
export default function scrollToElement(element, options = {}) {
  if (!element) {
    return;
  }

  const offset = options.offset === undefined ? 0 : options.offset;
  const duration = options.speed === undefined ? DEFAULT_DURATION : options.speed;
  const scroll = new SmoothScroll();

  if (typeof options.onComplete === 'function') {
    document.addEventListener('scrollStop', options.onComplete, { capture: true, once: true });
  }

  scroll.animateScroll(element, null, {
    speed: duration,
    speedAsDuration: true,
    offset,
  });
}
